import AppUtils from "@src/utils/appUtils";
import SignolUtils from "@src/utils/signolUtils";
//import { WEEK_TIME, MONTH_TIME, QUARTER_TIME } from 'constants/constants';
import {
  getManagerProfileResp,
  getNotificationTotalsResp,
  getLatestDataReceivedResp,
  getHighestOperatorMilestoneTotalsRespAviation,
  getHighestOperatorMilestoneTotalsRespMaritime,
  getSuccessRateVsPreSignolRespAviation,
  getSuccessRateVsPreSignolRespMaritime,
  getBehaviourSuccessRateOverTimeRespAviation,
  getBehaviourSuccessRateOverTimeRespMaritime,
  getBehaviourSuccessRatePerOperatorRespMaritime,
  getBehaviourSuccessRatePerOperatorRespAviation,
  getEventTotalsRespAviation,
  getEventTotalsRespMaritime,
  getVehiclesRespAviation,
  getVehiclesRespMaritime,
  getBehaviourFuelSavingVsPreSignolRespMaritime,
  getBehaviourFuelSavingVsPreSignolRespAviation,
  getBehaviourDataOverviewRespMaritime,
  getBehaviourDataOverviewRespAviation,
  getCalendarNotificationsPerTemplatePerDayAviation,
  getCalendarNotificationsPerTemplatePerDayMaritime,
  getPageViewsResp,
  getTeamVehiclesRespAviation,
  getTeamVehiclesRespMaritime,
  getBehaviourFuelSavingsPerOperatorRespAviation,
  getBehaviourFuelSavingsPerOperatorRespMaritime,
  getBehaviourFuelSavingsOverTimeRespAviation,
  getBehaviourFuelSavingsOverTimeRespMaritime,
  getRoutesRespAviation,
  getRoutesRespMaritime,
  getFeedbackSearchResultsRespAviation,
  getFeedbackSearchResultsRespMaritime,
} from "./managerObjectMocks";

const isShipping = () => SignolUtils.getIndustry() === "shipping";
const MILLISECONDS_IN_A_WEEK = 1000 * 60 * 60 * 24 * 7;

export function submitSupport() {
  const response = { result: true, message: "Ticket submitted successfully" };
  return AppUtils.simulateResponse(response);
}

export function submitProfileUpdate() {
  const response = null;
  return AppUtils.simulateResponse(response);
}

export function fetchDashboardUrl() {
  return AppUtils.simulateResponse({
    result: true,
    data: { dashboardEmbedUrl: "mockedUrl" },
  });
}

/** /managerDashboard/stats/highest-operator-milestone-reached-savings */
export function fetchHighestOperatorMilestoneTotals() {
  const fn = isShipping()
    ? getHighestOperatorMilestoneTotalsRespMaritime
    : getHighestOperatorMilestoneTotalsRespAviation;
  const response = fn();
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/vehicles */
export function fetchVehicles() {
  const fn = isShipping() ? getVehiclesRespMaritime : getVehiclesRespAviation;
  const response = fn();
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/notifications/total-per-type
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20NotificationTotalsResponseDto
 */
export function fetchNotificationTotals(teamId) {
  const response = getNotificationTotalsResp(teamId);
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/behaviours/success-rate-vs-pre
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20AvgSuccessRateBehaviourDto
 */
export function fetchBehaviourSuccessRateVsPreSignol(
  teamId,
  startDate,
  endDate,
) {
  console.debug("getBehaviourSuccessRateVsPreSignol");
  const fn = isShipping()
    ? getSuccessRateVsPreSignolRespMaritime
    : getSuccessRateVsPreSignolRespAviation;
  const response = fn(teamId, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchBehaviourDataOverviewStatusCounts(
  behaviourKey,
  teamId,
  startDate,
  endDate,
) {
  const fn = isShipping()
    ? getBehaviourDataOverviewRespMaritime
    : getBehaviourDataOverviewRespAviation;
  const response = fn(behaviourKey, teamId, startDate, endDate);
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/stats/event-totals
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20EventTotalsResponseDto
 */
export function fetchEventTotals(teamId) {
  const fn = isShipping()
    ? getEventTotalsRespMaritime
    : getEventTotalsRespAviation;
  const response = fn(teamId);
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/profile
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20GetManagerProfileResponseDto
 */
export function getManagerProfile(user) {
  const response = getManagerProfileResp(user);
  return AppUtils.simulateResponse(response);
}
/** /managerDashboard/stats/latest-data-received
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20GetLatestDataReceivedInfoResponseDto
 */
export function fetchLatestDataReceived() {
  const response = getLatestDataReceivedResp();
  return AppUtils.simulateResponse(response);
}

/** /managerDashboard/activities/page-views
 * @see https://github.com/Signolteam/managers_service/wiki/API-reference#get-activitiespage-views
 */
export function fetchPageViews() {
  const response = getPageViewsResp();
  return AppUtils.simulateResponse(response);
}

/** /managerDashboard/behaviours/success-rate-over-time
 */
export function fetchBehaviourSuccessRateOverTime(teamId, startDate, endDate) {
  const fn = isShipping()
    ? getBehaviourSuccessRateOverTimeRespMaritime
    : getBehaviourSuccessRateOverTimeRespAviation;
  const response = fn(teamId, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchBehaviourFuelSavingVsPreSignol(
  teamId,
  startDate,
  endDate,
) {
  const fn = isShipping()
    ? getBehaviourFuelSavingVsPreSignolRespMaritime
    : getBehaviourFuelSavingVsPreSignolRespAviation;
  const response = fn(teamId, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchNotificationsPerTemplatePerDay(
  teamId,
  startDate,
  endDate,
) {
  const fn = isShipping()
    ? getCalendarNotificationsPerTemplatePerDayMaritime
    : getCalendarNotificationsPerTemplatePerDayAviation;
  const response = fn(teamId, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchBehaviourSuccessRatePerOperator() {
  const fn = isShipping()
    ? getBehaviourSuccessRatePerOperatorRespMaritime
    : getBehaviourSuccessRatePerOperatorRespAviation;
  const response = fn();
  return AppUtils.simulateResponse(response);
}

export function fetchTeamVehicles(teamIds) {
  const fn = isShipping()
    ? getTeamVehiclesRespMaritime
    : getTeamVehiclesRespAviation;
  const response = fn(teamIds);
  return AppUtils.simulateResponse(response);
}

export function fetchBehaviourFuelSavingsPerOperator(
  behaviourName,
  teamIds,
  startDate,
  endDate,
) {
  const fn = isShipping()
    ? getBehaviourFuelSavingsPerOperatorRespMaritime
    : getBehaviourFuelSavingsPerOperatorRespAviation;
  const response = fn(behaviourName, teamIds, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchBehaviourFuelSavingsOverTime(
  behaviourName,
  teamIds,
  startDate,
  endDate,
) {
  const fn = isShipping()
    ? getBehaviourFuelSavingsOverTimeRespMaritime
    : getBehaviourFuelSavingsOverTimeRespAviation;
  const response = fn(behaviourName, teamIds, startDate, endDate);
  return AppUtils.simulateResponse(response);
}

export function fetchRoutes() {
  const shipping = isShipping();
  const response = shipping ? getRoutesRespMaritime() : getRoutesRespAviation();

  return AppUtils.simulateResponse(response);
}

export function fetchFeedbackSearchResults(params, body) {
  const fn = isShipping()
    ? getFeedbackSearchResultsRespMaritime
    : getFeedbackSearchResultsRespAviation;
  const response = fn(params, body);
  console.log("get comments", isShipping(), params, body, response);
  return AppUtils.simulateResponse(response);
}

export function executeDataQuery(mode, sqlQuery) {
  // Mock response with maritime sample data using new schema format
  const response = {
    status: "success",
    schema: [
      { name: "event_signol_id", type: "STRING", alias: "Report ID" },
      { name: "report_datetime", type: "DATETIME", alias: "Report Time" },
      { name: "report_type", type: "STRING", alias: "Report Type" },
      { name: "origin", type: "STRING", alias: "Origin" },
      { name: "destination", type: "STRING", alias: "Destination" },
      { name: "ship_name", type: "STRING", alias: "Vessel Name" },
      { name: "ship_imo", type: "NUMBER", alias: "Vessel IMO" },
    ],
    rows: [],
    row_count: 0,
  };

  return AppUtils.simulateResponse(response);
}

export function downloadDataQuery({ sql, headersFormat }) {
  const response = {
    download_link: `https://example.com/download/query-results-${headersFormat}.csv`,
    download_expires_in: 3600,
  };

  return AppUtils.simulateResponse(response);
}
